var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
Aedu.Notifications.Notification = function (superClass) {
  extend(Notification, superClass);
  function Notification() {
    return Notification.__super__.constructor.apply(this, arguments);
  }
  Notification.prototype.view = function () {
    return {
      el: this.get('html')
    };
  };
  return Notification;
}(Backbone.Model);
window.extend = extend;
window.hasProp = hasProp;